<template>
  <div>
    <div>
      <div v-if="loaded && storageReceipts.length === 0">
        <div class="alert alert-primary" role="alert">
          رسید فضای ابری یافت نشد.
        </div>
      </div>
    </div>

    <div
      v-if="loaded && storageReceipts.length"
      class="card card-custom gutter-b"
    >
      <div class="card-body">
        <div class="table-responsive rounded border-1">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>کد</th>
                <th>حجم</th>
                <th v-if="isAdmin">کاربر</th>
                <th v-if="isCompany || isAdmin">مصرف کننده</th>
                <th>مبلغ (ریال)</th>
                <th>تاریخ</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="storageReceipt in storageReceipts"
                :key="storageReceipt.id"
              >
                <td dir="ltr">{{ storageReceipt.id }}</td>
                <td dir="ltr" class="text-nowrap">
                  {{
                    storageReceipt.items
                      ? bytesToHuman(storageReceipt.items.size)
                      : ""
                  }}
                </td>
                <td v-if="isAdmin" class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'admin-users-show',
                      params: { id: storageReceipt.user_id }
                    }"
                    class="text-primary"
                  >
                    {{ gFullName(storageReceipt.user) || "_" }}
                  </router-link>
                </td>
                <td v-if="isCompany || isAdmin">
                  <router-link
                    v-if="storageReceipt.consumer_id && isAdmin"
                    :to="{
                      name: 'admin-users-show',
                      params: { id: storageReceipt.consumer_id }
                    }"
                    class="text-primary"
                  >
                    {{ gFullName(storageReceipt.consumer) || "_" }}
                  </router-link>
                  <router-link
                    v-if="storageReceipt.consumer_id && isCompany"
                    :to="{
                      name: 'company-users-show',
                      params: { id: storageReceipt.consumer_id }
                    }"
                    class="text-primary"
                  >
                    {{ gFullName(storageReceipt.consumer) || "_" }}
                  </router-link>
                </td>
                <td dir="ltr">{{ numberFormat(storageReceipt.total) }}</td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(storageReceipt.created_at) }}
                </td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: receiptRouteName,
                      params: { id: storageReceipt.id }
                    }"
                    class="btn btn-xs btn-outline-primary"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      class="overflow-auto mt-5"
      v-if="storageReceiptsPagination.lastPage > 1"
    >
      <b-pagination
        v-model="storageReceiptsPagination.currentPage"
        :total-rows="storageReceiptsPagination.total"
        :per-page="storageReceiptsPagination.perPage"
        aria-controls="my-table"
        @input="updateStorageReceipts()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_STORAGE_RECEIPTS,
  FETCH_ADMIN_STORAGE_RECEIPTS
} from "@/core/services/store/receipts/storage.module";
import { mapGetters } from "vuex";

export default {
  name: "storageReceipts",
  data() {
    return {
      loaded: false,
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin"),
      receiptRouteName: "receipts-storage-show",
      action: FETCH_STORAGE_RECEIPTS
    };
  },
  mounted() {
    this.setBreadcrumbs();
    this.$store.dispatch(SET_ACTIONS, {});

    if (this.isCompany) {
      this.receiptRouteName = "company-receipts-storage-show";
    }
    if (this.isAdmin) {
      this.receiptRouteName = "admin-receipts-storage-show";
      this.action = FETCH_ADMIN_STORAGE_RECEIPTS;
    }

    this.updateStorageReceipts();
  },
  computed: {
    ...mapGetters(["storageReceipts", "storageReceiptsPagination"])
  },
  methods: {
    updateStorageReceipts() {
      this.loaded = false;

      this.$store
        .dispatch(this.action)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    setBreadcrumbs() {
      let items = [];
      if (this.isCompany) {
        items.push({
          title: this.currentUserProperty.title ?? "شرکت",
          route: { name: "company-dashboard" }
        });
      }
      if (this.isAdmin) {
        items.push({
          title: "مدیریت",
          route: { name: "admin-dashboard" }
        });
      }

      items.push({ title: "رسیدهای فضای ابری" });

      this.$store.dispatch(SET_BREADCRUMB, items);
    }
  },
  watch: {
    "$route.name": {
      handler: function(to, from) {
        if (from !== undefined) {
          this.eventHub.$emit("re_render_page", this);
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
